import React, {Component} from 'react';
import {Button, Row} from 'src/components/Common/reactstrap/lib';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../RegistrationPopup/redux/registrationPopupActions';
import * as logInActions from 'src/components/SignInPopup/redux/signInPopupActions';
import {setNewPhone} from '../redux/userAction.js';
import styles from 'src/styles/AuthPopup.scss';
import TelephoneInput from 'react-telephone-input';
import config from 'src/config';
import {isValidNumber} from 'src/logic/utils';
import cx from 'classnames';
import debounce from 'lodash/debounce';
import * as texts from 'src/texts';
const phoneInputImgs = require('src/imgs/flags.png');
import {findDOMNode} from 'react-dom';
import PopoverTrigger from 'src/components/popover/PopoverTrigger';
import fm from 'src/logic/formatMessage';

class EditPhoneInputFirstStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true,
      phoneValue: this.props.value,
      editPhone: false
    };
    this.editPhone = this.editPhone.bind(this);
    this.submitPhone = this.submitPhone.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      phoneValue: nextProps.value
    });
  }

  editPhone() {
    const inputValue = this.refs.phoneInput.getInstance().getValue().replace(/[\s-]/g, '');
    const propsValue = this.props.value.replace(/[\s-]/g, '');

    if (inputValue && propsValue != inputValue && inputValue.length == 12) {
      this.setState({
        editPhone: true
      });
    }
    else {
      this.setState({
        editPhone: false
      });
    }
  }

  submitPhone(e) {
    const value = this.refs.phoneInput.getInstance().getValue();
    if (this.props.value != value) {
      if (!isValidNumber(value)) {
        return false
      }
      //var setNewPhone = this.props.setNewPhone;
    this.props.requestChangePhonePass(value)
      .then((res) => {
        if(res.error)
          alert(res.error);
        else {
          this.setState({
            editPhone: false
          });
          this.props.setNewPhone(value);
        }
      });
    }
  }

  onChange = debounce((value) => {
    this.editPhone();

    if (value.length < config.minLengthForNumberVerifying) {
      this.setState({isValid: true});
      return this.props.resetErrors();
    }
    this.setState({
      isValid: isValidNumber(value),
      phoneValue: value
    });
  }, 200);

  render() {
    const {regInputCurStep, sentNumberErr, popoverOnTop, isCompact} = this.props;
    const {isValid} = this.state;
    const phoneInputContainerClassName = {
      [styles.telephoneInputContainer]: true,
      [styles.invalidInput]: !isValid || !!sentNumberErr,
      'w-100': !isCompact
    };

    const phoneNumberTooltipType = (isValid && !sentNumberErr)
      ? ''
      : 'error';

    let sendCodeButton = (this.state.editPhone)? <Button onClick={this.submitPhone} className="mm-r-4 p-y-0"> Выслать код </Button> : '';
    return (
      <Row>
        <TelephoneInput
          ref="phoneInput"
          value={this.state.phoneValue}
          classNames="custom-phone-input"
          defaultCountry='ru'
          preferredCountries={config.phoneInputCodeSelectorPreferredCountries}
          flagsImagePath={phoneInputImgs}
          onChange={this.onChange}

        />
        {sendCodeButton}
      </Row>
    );
  }
}

export default connect(
  (state) => ({...state.registrationPopupReducer}),
  (dispatch) => ({
    ...bindActionCreators(actions, dispatch),
    ...bindActionCreators(logInActions, dispatch),
    setNewPhone: bindActionCreators(setNewPhone, dispatch)
  })
)(EditPhoneInputFirstStep);



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/EditPhoneInputFirstStep.jsx
 **/